import api from "../axios_service.js";

export async function fetchEquipes(filtros) {
  const response = await api.get(
    `/colaborador/clientes-equipe${filtros ? filtros : ""}`
  );
  return response.data.result;
}
